// ES6 polyfill
import 'babel-polyfill';

// requestAnimationFrame polyfill
import 'requestanimationframe';

// Custom modernizr configuration
import './libs/modernizr';

// fetch polyfill
import 'whatwg-fetch';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

// ie11 grid support
import 'polyfill/grid';

// 99designs global navigation
require(['common/components/globalNav'], createGlobalNav => {
    createGlobalNav.default();
});
